<template>
    <div class="bigDataPlatform">
        大数据运行平台
    </div>
</template>

<script>
export default {
  name: "bigDataPlatform",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
